// src/features/player/playerProgressApi.ts
import { createApi } from '@reduxjs/toolkit/query/react'
import { mockBaseQuery } from '@/mocks/mockBaseQuery'

export const playerProgressApi = createApi({
  reducerPath: 'playerProgressApi',
  baseQuery: mockBaseQuery,
  endpoints: (build) => ({
    getProgress: build.query<{ completedLessonIds: number[] }, number>({
      query: (courseId) => `player-progress/${courseId}`,
    }),
  }),
})

export const { useGetProgressQuery } = playerProgressApi
